import React, { memo, useMemo } from 'react';
import { makeStyles } from '@mui/styles';
import DpdPinIcon from '../icons/DpdPin';
import MarkerContainer from './MarkerContainer';
import palette from '../styles/palette';
import { Text } from '../Base';

const useStyles = makeStyles(({ typography }) => {
  const { pxToRem } = typography;
  return {
    icon: {
      width: pxToRem(26),
      height: pxToRem(26),
    },
    title: {
      fontFamily: 'Roboto',
      fontWeight: 500,
      fontSize: pxToRem(12),
      lineHeight: pxToRem(8),
      letterSpacing: '0.04em',
      textTransform: 'capitalize',
      color: palette.grey55,
      width: 'max-content',
      position: 'absolute',
      top: pxToRem(-12),
    },
    activeContainer: {
      backgroundColor: palette.darkGreen,
      '&::after': {
        borderTop: `13px solid ${palette.darkGreen}`,
      },
    },
  };
});

const DepotMarker = ({ depot, isSelected }) => {
  const styles = useStyles();

  const getDepotColor = (businessUnit) => {
    switch (businessUnit) {
      case 2:
        return palette.blue;
      case 3:
        return palette.green;
      default:
        return palette.dpdRed;
    }
  };
  const fillColor = useMemo(() => getDepotColor(depot.businessUnit), [depot]);

  return (
    <MarkerContainer
      data-testid={`depot-${depot.depotCode}`}
      className={isSelected && styles.activeContainer}
    >
      <Text
        className={styles.title}
      >{`${depot.depotName} - ${depot.depotCode}`}</Text>
      <DpdPinIcon className={styles.icon} color={fillColor} />
    </MarkerContainer>
  );
};

export default memo(DepotMarker);
